import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'charactersLimit'
})
export class CharactersLimitPipe implements PipeTransform {

  transform(value: any, noOfCharacter: number): any 
  {
     if(value.length<=noOfCharacter)
     	return value;
     return value.substring(0,noOfCharacter-1)+"...";
  }

}
